import { render, staticRenderFns } from "./UpdateCustomerType.vue?vue&type=template&id=1843f4df&scoped=true"
import script from "./UpdateCustomerType.vue?vue&type=script&lang=js"
export * from "./UpdateCustomerType.vue?vue&type=script&lang=js"
import style0 from "./UpdateCustomerType.vue?vue&type=style&index=0&id=1843f4df&prod&scoped=true&lang=css"
import style1 from "./UpdateCustomerType.vue?vue&type=style&index=1&id=1843f4df&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1843f4df",
  null
  
)

export default component.exports